import { loadCurrentPerson, Name } from "./person";
import { loadProfile } from "./profile";
export const loadCurrentName = async (db, netID) => {
  const person = await loadCurrentPerson(db, netID);
  if (!person) {
    return;
  }
  const profile = await loadProfile(db, netID);
  if (!profile) {
    return Name.check(person.name);
  } else {
    const first = profile.name || person.name.first;
    return Name.check({ last: person.name.last, first, full: `${first} ${person.name.last}` });
  }
};
//# sourceMappingURL=name.js.map
